import style from '#src/client/common/elements/Details.module.css';
import { splitProps } from 'solid-js';

export default function Details(props) {
    const [local, others] = splitProps(props, [
        'class',
    ]);

    const classes = () => {
        return [
            local.class,
            style.detail,
        ].join(' ');
    };

    return (
        <details {...others} class={classes()}>
            <summary class={style.summary}>{props.label}</summary>
            <div class={style.content}>{props.children}</div>
        </details>
    );
}